<template>
	<section class="costompopup pop_sm1">
		<div class="middleBox  platfromBox"> 
			<div class="darkBG platfromBox_title p-3 mb-0">  
				<h4 class="mb-0"> Warnings Notice</h4>
				<!-- <feather class="close" @click="pageRedirectFunc('')" type="x"></feather> -->
			</div>
			<div class="d-block p-4">
				<p class="mb-3"  v-if="get_user.profile.total_points <= 15"> 
					<!-- fail case data  -->
					Dear {{get_user.profile.firstname}},<br>

					Please note that based on the answers you have provided, you did not pass the appropriateness assessment. Therefore, we concluded that CFD products are not appropriate for you and we recommend you to gain more knowledge and experience by getting familiar with our educational material or practicing on our Demo account.
					However, you may continue the onboarding process by acknowledging the below risk involved in CFDs financial instruments.<br>
					CFDs are complex  and come with a high risk of losing money rapidly due to leverage. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.You should be aware of all the risks associated with trading CFDs, and seek advice from an independent adviser if you have any doubts. Please refer to our <a href="https://fxview.com/assets/pdf/legal-document/Risk-Disclosure-and-Warnings-Notice-August-2023.pdf" target="_blank">Risk Disclosure And Warnings Notice</a> for more information. 
					<!-- <p>{{ select_risk }}</p> -->
				</p>
				<p class="mb-3"  v-else> 
					<!-- pass case data  -->
					Dear {{get_user.profile.firstname}},<br>

					Please note that based on the answers you have provided, you passed the appropriateness assessment. Therefore you may proceed with the onboarding process.
					Please keep in mind that CFDs are complex  and come with a high risk of losing money rapidly due to leverage. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.
				</p>

				<div v-if="get_user.profile.total_points <= 15">
					<!-- failed case button -->
					<div class="d-flex justify-content-between mb-2 mb-md-0">
						<div>
							<label class="fancy_radiochk_btn ibancheckbox stitle mb-0 none-before">
								<div>
									<p class="mb-0">I accept the risk</p>
									<input type="checkbox" v-model="accepted" @input="rejected = false">
									<span class="checkmark"></span>
								</div>
							</label>
						</div>
						<div>
							<label class="fancy_radiochk_btn ibancheckbox stitle mb-0 none-before">
								<div>
									<p class="mb-0">I do not accept</p>
									<input type="checkbox" v-model="rejected" @input="accepted = false">
									<span class="checkmark"></span>
								</div>
							</label>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<button type="button" class="prism_btn btn_sm" @click="accepted?submit():null" :disabled="!accepted">Proceed</button>

						<button type="button" class="btn btn-danger btn_sm"  @click="rejected?submit():null" :disabled="!rejected">I do not want to proceed</button>
					</div>
				</div>
				<div class="d-flex align-items-center justify-content-end" v-else="">
					<!-- pass case button -->
					<button class="prism_btn btn_sm" @click="$parent.showRisk = false">Proceed</button>
				</div>

			</div>
			 
		</div>
	</section>
</template>
<script>
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'steps',
		mixins: [fxViewMixins],
        data() {
            return {
				submitted: false,
				items: {
					1: 'I accept the risk',
					2: 'I do not accept'
				},
				accepted: false,
				rejected: false,
			}
        },
		methods:{
			...mapActions({
                _runSetRiskWarningPopup: types.SET_RISK_WARNING_POPUP
            }),
			submit(){
				if(this.accepted){
					this.$trackEvent('CP+Client+Verification+8+Next')
				}else{
					this.$trackEvent('CP+Client+Verification+8+Cancel')
				}
				if( this.accepted === this.rejected){
					return;
				}
				const _that = this
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
					if (valid) {
						let input_json={
							'globalParams' :{
								'risk_warning' : (_that.accepted ? 1 : 2), 
							},
							'localParams' :{ "parameter" : _that }
						}
						console.log(input_json)
						_that._runSetRiskWarningPopup(input_json)
					}else{
						_that.handleValidationErrorAdvanced(_that.errors)
					}
				})
			}
		},
		created(){
			this.$trackEvent('CP+Client+Verification+8+Pageview')
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/warnings-notice.vue